module.exports = __webpack_public_path__ + "static/media/Data_Bitcoin.66169d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Data_Bitcoin.png
// module id = 234
// module chunks = 0